import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

// core
import {
  Box,
} from '@material-ui/core';
import { useParams, Link } from 'react-router-dom';

// components
import useStyles from './styles';
import {
  // getSurveyResponsesTeleaudit,
  // getSurveyResponsesReaudit,
  getSurveyResponseForTeleaudit,
  getSurveyResponseForReaudit,
} from '../../../requests/api/survey-response';
import { UNAUTHORIZED } from '../../../utils/const/http';
import SurveyQuestionBox from './questionsBox';
import Button from '../../../components/Button';

const QuestionResponsesTeleauditView = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  // const { t } = useTranslation();

  // table states
  // const page = 0;
  // const rowsPerPage = 10;
  const [data, setData] = useState([]);
  const [dataReaudit, setDataReaudit] = useState([]);
  const { taskResponseId, type } = useParams();

  const requestSearch = async () => {
    // const response = await getSurveyResponsesTeleaudit(
    //   { id: taskResponseId, page: pageOfTable, limit },
    // );
    const response = await getSurveyResponseForTeleaudit(taskResponseId, type);

    if (response.success) {
      setData(response.data.data.QuestionResponses);
    }

    if (response.status === UNAUTHORIZED.status) {
      window.location.href = '/home';
    }
  };

  const requestSearchReaudit = async () => {
    const response = await getSurveyResponseForReaudit(taskResponseId);

    if (response.success) {
      setDataReaudit(response.data.data.QuestionResponses);
    }

    if (response.status === UNAUTHORIZED.status) {
      window.location.href = '/home';
    }
  };

  const requestSearchRef = useRef(requestSearch);
  requestSearchRef.current = requestSearch;
  const requestSearchReauditRef = useRef(requestSearchReaudit);
  requestSearchReauditRef.current = requestSearchReaudit;

  useEffect(() => {
    requestSearchRef.current();
    requestSearchReauditRef.current();
  }, []);

  return (
    <>
      <div className={styles.content}>
        <Button
          align='right'
          id="back-btn"
          text={t('teleaudit.buttons.back')}
          variant="contained"
          height="40px"
          width="170px"
          backgroundColor='theme-custom-solidButtonBackground'
          color='theme-custom-solidButtonText'
          borderRadius='10px'
          component={Link}
          to="/teleaudit"
          />
        <div className={styles.header}>
          <Box sx={{ width: '100%' }}>
            <SurveyQuestionBox
              questions={data}
              reaudit={false}
            />
          </Box>
        </div>
        <div className={styles.header}>
          <Box sx={{ width: '100%' }}>
            <SurveyQuestionBox
              questions={dataReaudit}
              reaudit={true}
            />
          </Box>
        </div>
      </div>
    </>
  );
};

export default QuestionResponsesTeleauditView;
